import { memo } from "react";
import {
  Box,
  Button,
  Typography,
  styled,
} from "@mui/material";
import {
  Upload as UploadIcon,
} from "@mui/icons-material";

// ─── Styled Components ───────────────────────────────────────────────────────

const SectionCard = styled(Box)({ 
  backgroundColor: "white",
  borderRadius: "0.75rem",
  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
  padding: "1rem",
  marginBottom: "0.95rem",
});

const SectionTitle = styled(Typography)({
  fontSize: "1.125rem",
  fontWeight: 700,
  color: "#1e293b",
  marginBottom: "1rem",
});

const ActionButton = styled(Button)({
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.875rem",
  padding: "10px 24px",
  borderRadius: "9999px",
});

const DangerButton = styled(ActionButton)({
  backgroundColor: "#ef4444",
  color: "white",
  "&:hover": { backgroundColor: "#dc2626" },
});

// ─── Component ───────────────────────────────────────────────────────────────

const CardMeGenFinalVideoDirectScript = memo(
  (props: {
    runName: string;
    videoPath: string;
    isReadyForUpload: boolean;
    onUploadToYoutube: () => void;
  }) => {
    if (!props.videoPath) return null;
    return (
      <SectionCard id="megen-gen-direct-final-video-card">
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "1rem",
          }}
        >
          <SectionTitle>Final Output: {props.runName}</SectionTitle>
          {props.isReadyForUpload && (
            <DangerButton id="megen-gen-direct-upload-youtube-btn" startIcon={<UploadIcon />} onClick={props.onUploadToYoutube}>
              Upload to YouTube
            </DangerButton>
          )}
        </Box>
        <Box
          id="megen-gen-direct-final-video-player"
          component="video"
          controls
          src={props.videoPath}
          sx={{
            width: "100%",
            borderRadius: "0.5rem",
            backgroundColor: "black",
            aspectRatio: "16/9",
          }}
        />
      </SectionCard>
    );
  },
);

export default CardMeGenFinalVideoDirectScript;
